import { faEyeSlash } from "@fortawesome/pro-duotone-svg-icons";
import ColorChangingIcon from "../Common/UI/ColorChangingIcon";

function HidePermissionsButton({ onClick }) {
  return (
    <ColorChangingIcon
      title="Hide Permissions"
      icon={faEyeSlash}
      initialPrimaryColor="#d6912a"
      initialSecondaryColor="#c91a0e"
      initialSize={18}
      hoverSize={18}
      margin="0 0 0 5px"
      onClick={onClick}
    />
  );
}

export default HidePermissionsButton;
